export const testId = (testId) => {
  const hideTestId = process.env.NODE_ENV === "production";

  return (
    !hideTestId && {
      "data-testid": testId,
    }
  );
};
